import {
  DEFAULT_NA,
  PROFILE_SUBNAME,
} from '../newrelic-constants';

import {
  getEnvironmentMicro,
} from '../newrelic-helpers';

export function nrEnrollment(globalState, actionName, fullStory, metricData) {
  const data = {
    actionSubname: PROFILE_SUBNAME.WEBENROLLMENT,
    environment: getEnvironmentMicro(),
    flow: 'MYB',
    subflow: 'ancillary',
    step: metricData?.action?.funnel,
    fullstory: fullStory || DEFAULT_NA,
    resultState: metricData?.resultState,
    storefront: metricData?.storefront,
    url: window?.location?.href,
    errorCode: metricData?.rqResult?.code || '*',
    promotions: '*',
    referredAdn: '*',
    referredCampaign: '*',
    isRetroactive: '*',
    guardianAccount: '*',
    ffn: '*',
    entryPoint: 'Modal Login',
    request: '*',
  };

  if (metricData?.action?.guardianAccount) {
    data['guardianAccount'] = metricData?.action?.guardianAccount;
  }

  if (metricData?.rqResult?.accountNumber) {
    data['ffn'] = metricData?.rqResult?.accountNumber;
  }

  window.newrelic.addPageAction(actionName, data);
}
